/* eslint-disable prefer-destructuring */
import { DatePicker } from 'antd';
import IconComponent from 'components/common/IconComponent';
import { DEFAULT_FORMAT_DATE_INPUT_US, FORMAT_DATE } from 'constants/days';
import useWindowSize from 'hooks/useWindowSize';
import moment from 'moment';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { getFormattedDate } from 'utils';

import DatePickerInput from './DatePickerInput';
import { ICommonInputProps } from './types';

const { RangePicker } = DatePicker;

const RangeContainerStyled = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  & > div:first-child {
    width: 50%;
    input,
    .date-picker-input {
      font-size: 14px;
      border-right: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      width: 100%;
      &:hover {
        border-right: none;
        box-shadow: none;
      }
    }
  }
  & > div:last-child {
    width: 50%;
    input,
    .date-picker-input {
      font-size: 14px;
      border-left: none;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      width: 100%;
      &:hover {
        border-left: none;
        box-shadow: none;
      }
    }
  }
`;

const ArrowContainerStyled = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const RangePickerInput: React.FC<ICommonInputProps> = ({ defaultValue, name, value, onChange, onBlur }) => {
  const { isMobile } = useWindowSize(576);
  const handleChange = useCallback(
    (_, dateString: any[]) => {
      if (dateString) onChange?.(dateString.map((ds) => moment(ds, DEFAULT_FORMAT_DATE_INPUT_US).format(FORMAT_DATE)));
      else {
        onChange?.(undefined);
      }
    },
    [onChange],
  );

  const handleChangeMobileVer = (newVal: string | Date, index: number) => {
    const convertedNewVal = moment(newVal).format(FORMAT_DATE);
    const newDateRangeValue = [...value];
    newDateRangeValue.splice(index, 1, convertedNewVal);
    onChange?.(newDateRangeValue);
  };
  let dateFormat: any;
  const momentDefaultValue = defaultValue
    ? defaultValue.map((e: string | Date) => {
        const formattedDateData = getFormattedDate(e);
        if (!dateFormat) {
          dateFormat = formattedDateData[1];
        }
        return formattedDateData[0];
      })
    : undefined;

  const momentValue = value
    ? value.map((v: string | Date) => {
        const formattedDateData = getFormattedDate(v);
        if (!dateFormat) {
          dateFormat = formattedDateData[1];
        }
        return formattedDateData[0];
      })
    : undefined;

  return isMobile ? (
    <RangeContainerStyled
      ref={(ref) => {
        ref?.setAttribute('name', name);
      }}>
      <div>
        <DatePickerInput
          name=''
          defaultValue={defaultValue?.[0]}
          value={value?.[0]}
          onChange={(v: string) => {
            handleChangeMobileVer(v, 0);
          }}
        />
      </div>
      <ArrowContainerStyled>
        <IconComponent name='long-arrow-right' size={14} />
      </ArrowContainerStyled>
      <div>
        <DatePickerInput
          name=''
          defaultValue={defaultValue?.[1]}
          value={value?.[1]}
          onChange={(v: string) => {
            handleChangeMobileVer(v, 1);
          }}
        />
      </div>
    </RangeContainerStyled>
  ) : (
    <RangePicker
      dropdownClassName='custom-range-picker'
      name={name}
      defaultValue={momentDefaultValue}
      className='gx-w-100 range-picker-input'
      size='middle'
      onChange={handleChange}
      onBlur={onBlur}
      value={momentValue}
      format={[DEFAULT_FORMAT_DATE_INPUT_US, dateFormat || FORMAT_DATE]}
    />
  );
};

export default React.memo(RangePickerInput);
